import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../../../shared/shared.module';
import { DescriptionAndFeaturesFormComponent } from './description-and-features.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AsyncButtonModule } from '../../../../../../shared/directives/async-button/async-button.module';
import { VesselSaveButtonModule } from '../../vessel-save-button/vessel-save-button.module';
import { WysiwygEditorModule } from '../../../../../../shared/wysiwyg-editor/wysiwyg-editor.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    MatDialogModule,
    MatIconModule,
    AsyncButtonModule,
    VesselSaveButtonModule,
    WysiwygEditorModule,
  ],
  declarations: [DescriptionAndFeaturesFormComponent],
  entryComponents: [],
  exports: [DescriptionAndFeaturesFormComponent],
  providers: [],
})
export class DescriptionAndFeaturesFormModule {}
